<p-blockUI [blocked]="blockedDocument">
    <i class="pi pi-spin pi-spinner" style="font-size: 5rem"></i>
</p-blockUI>

<ng-container *ngFor="let error of errorMessages">
        <p-messages severity="error" [closable]="true">
        
                <ng-template  pTemplate>
                    <div class="ml-2 justify-content-start"> <i>{{ error }}</i><br/> </div>
                </ng-template>
        </p-messages>
    </ng-container>


<p-messages severity="info">
    <ng-template pTemplate>
        <div class="ml-2 justify-content-start">Hello <b><i>{{ localeName }}</i></b> Locale!. Welcome to Ushers Report! Before you start, please complete your weekly reports.</div>
    </ng-template>
</p-messages>

<p-toolbar 

    [style]="{ 'border-radius': '3rem'}">
        <ng-template pTemplate="start">
            <div class="flex align-items-center gap-2">
                <img src="assets/layout/images/logo_pmcc4w.webp" width="60">

                <p-dropdown 
                [options]="yearOptions"
                [(ngModel)]="selectedYear"
                (onChange)="onSelectYear($event)"
                placeholder="Select Year" />
            </div>
        </ng-template>
        <ng-template pTemplate="center">
            <div class="flex flex-wrap p-fluid">
                @if(access !== 'ROLE_MINISTER') {
                    <p-dropdown 
                    [options]="locales"
                    filter="true"
                    [(ngModel)]="selectedLocale"
                    (onChange)="onSelect($event)"
                    optionValue="localeId"
                    optionLabel="localeName"
                    placeholder="Select Locale" />
                }
            </div>
        </ng-template>
        <ng-template pTemplate="end">
            <div class="flex align-items-center gap-2">
                <p-avatar 
                    [image]="photo" 
                    shape="circle" />
                <span class="font-bold">
                  {{name}}
                </span>
            </div>
        </ng-template>
</p-toolbar>

<!-- <div class="card" >
    <div class="grid">
        <div class="col-9">
            <div class="ml-2 justify-content-start">Hello <b><i>{{ localeName }}</i></b> Locale!. Welcome to Ushers Report! Before you start, please complete your weekly reports.</div>
        </div>
    </div>
</div> -->
<br>

<!-- <div class="dashboard ">
    <h1>{{localeName}} Locale Dashboard {{currentYear}}</h1>
</div> -->


<p-panel [header]="header">
    <div class="grid">
        <div class="col-12" *ngIf="!blockedDocument">
            <!-- <div class="card">
                <div class="card-header gap-3 pb-2">
                    <div class="card-title">
                        <h6>Weekly Report Updates</h6>
                        <p class="subtitle">Click edit to complete the report.</p>
                    </div>
                </div> -->
                <p-tabView (onChange)="changeTab($event)">
                    <ng-container *ngFor="let tab of items">
                        <p-tabPanel  class="w-full p-0">
                            <ng-template pTemplate="header">
                                @if(tab.label === 'Encoding Needed' ) {
                                    <div  class="pr-2" pBadge value="{{tab.count}}" severity="danger">
                                        <h6 class="m-0 mr-2">{{ tab.label }}</h6>
                                    </div>
                                }@else if(tab.label === 'Draft') {
                                    <div  class="pr-2" pBadge value="{{tab.count}}" severity="warning">
                                        <h6 class="m-0 mr-2">{{ tab.label }}</h6>
                                    </div>
                                }@else {
                                    <div  class="pr-2" pBadge value="{{tab.count}}" severity="success">
                                        <h6 class="m-0 mr-2">{{ tab.label }}</h6>
                                    </div>
                                }
    
                            </ng-template>
                            <p-table #dt1 
                            [value]="weeks" 
                            [scrollable]="true" 
                            scrollHeight="400px" 
                            selectionMode="single"
                            styleClass="p-datatable-hover"
                            [globalFilterFields]="['status']"
                            >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pSortableColumn="startDate">Date <p-sortIcon field="startDate" /></th>
                                    <th></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-week>
                                <tr>
                                    <td>{{week.startDate | date : 'mediumDate' }} to {{week.endDate | date : 'mediumDate' }}</td>
                                    <td>
                                        @if(week.status === 'ENCODING NEEDED') {
                                            <button pButton pRipple type="button" label="Edit" class="p-button-sm" (click)="createAndRedirect(week)" ></button>
                                        }@else {
                                            <button pButton pRipple type="button" label="Edit" class="p-button-sm" [routerLink]  = "['/encoding/weekly-report/' + week.postingPeriodId]" ></button>
                                        }
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        </p-tabPanel>
                </ng-container>
                </p-tabView>
            <!-- </div> -->
        </div>
    </div>
</p-panel>




<!-- <div class="grid">
    <div class="col-12" *ngIf="blockedDocument == false">
        <div class="card">
        <p-table #dt1 
            [value]="weeks" 
            [scrollable]="true" 
            scrollHeight="400px" 
            selectionMode="single"
            styleClass="p-datatable-hover p-datatable-striped"
            [globalFilterFields]="['status']"
            >
            <ng-template pTemplate="caption">
                <div class="flex">
                    <h5>Weekly Report Updates</h5>
                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')" placeholder="Search keyword" style="padding-right: 5px" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="startDate">Date <p-sortIcon field="startDate" /></th>
                    <th pSortableColumn="status">Status <p-sortIcon field="status" /></th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-week>
                <tr>
                    <td>{{week.startDate | date : 'mediumDate' }} to {{week.endDate | date : 'mediumDate' }}</td>
                    <td>

                        @if(week.status == 'DRAFT'){
                           <p class="draft">{{week.status}}</p>
                        }@else if(week.status == 'ENCODING NEEDED'){
                            <p class="encoding">{{week.status}}</p>
                        }@else if(week.status == 'SUBMITTED'){
                            <p class="submitted">{{week.status}}</p>
                        }@else if(week.status == 'IN_REVIEW'){
                            <p class="inreview"> IN REVIEW </p>
                        }@else if(week.status == 'ACKNOWLEDGED'){
                            <p class="acknowledged">{{week.status}}</p>
                        }


                    </td>
                    <td>
                        @if(week.status == 'DRAFT'){
                            <button pButton pRipple type="button" [icon]="'pi pi-file-edit'" class="p-button-sm p-button-text" [routerLink]  = "['/encoding/weekly-report/' + week.postingPeriodId]" ></button>
                        }@else if(week.status == 'ENCODING NEEDED'){
                            <button pButton pRipple type="button" [icon]="'pi pi-pencil'" class="p-button-sm p-button-text" (click)="createAndRedirect(week)"></button>
                        }@else if(week.status == 'SUBMITTED'){
                            <button pButton pRipple type="button" [icon]="'pi pi-check-circle'" class="p-button-sm p-button-text" [routerLink]  = "['/encoding/weekly-report/' + week.postingPeriodId]"></button>
                        }@else if(week.status == 'IN-REVIEW'){
                            <button pButton pRipple type="button" [icon]="'pi pi-clock'" class="p-button-sm p-button-text" [routerLink]  = "['/encoding/weekly-report/' + week.postingPeriodId]"></button>
                        }@else if(week.status == 'ACKNOWLEDGED'){
                            <button pButton pRipple type="button" [icon]="'pi pi-verified'" class="p-button-sm p-button-text" [routerLink]  = "['/encoding/weekly-report/' + week.postingPeriodId]"></button>
                        }

                        <button pButton pRipple type="button" label="Edit" class="p-button-sm" [routerLink]  = "['/encoding/weekly-report/' + week.postingPeriodId]" ></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        </div>
    </div>

    <div class="col-12">
        <div class="grid" style="margin: -1rem">
            <div class="col-12 sm:col">
                <div class="card surface-card text-500 flex justify-content-between pt-4 h-full" style="min-width: 17rem">
                    <div class="overview-info">
                        <h6 class="m-0 mb-1 text-500">Remittances</h6>
                        <h1 class="m-0 text-500">300M</h1>
                    </div>
                    <i class="pi pi-chart-line text-3xl"></i>
                </div>
            </div>
            <div class="col-12 sm:col">
                <div class="card surface-card text-500 flex justify-content-between pt-4 h-full" style="min-width: 17rem">
                    <div class="overview-info">
                        <h6 class="m-0 mb-1 text-500">Tithes & Offering</h6>
                        <h1 class="m-0 text-500">1548.26</h1>
                    </div>
                    <i class="pi pi-dollar text-3xl"></i>
                </div>
            </div>
            <div class="col-12 sm:col">
                <div class="card surface-card text-500 flex justify-content-between pt-4 h-full" style="min-width: 17rem">
                    <div class="overview-info">
                        <h6 class="m-0 mb-1 text-500">Expenses</h6>
                        <h1 class="m-0 text-500">2</h1>
                    </div>
                    <i class="pi pi-envelope text-3xl"></i>
                </div>
            </div>
            <div class="col-12 sm:col">
                <div class="card surface-card text-500 flex justify-content-between pt-4 h-full" style="min-width: 17rem">
                    <div class="overview-info">
                        <h6 class="m-0 mb-1 text-500">Attendances</h6>
                        <h1 class="m-0 text-500">12%</h1>
                    </div>
                    <i class="pi pi-chart-bar text-3xl"></i>
                </div>
            </div>
            <div class="col-12 sm:col">
                <div class="card surface-card text-500 flex justify-content-between pt-4 h-full" style="min-width: 17rem">
                    <div class="overview-info">
                        <h6 class="m-0 mb-1 text-500">Visitors</h6>
                        <h1 class="m-0 text-500">4</h1>
                    </div>
                    <i class="pi pi-box text-3xl"></i>
                </div>
            </div>
        </div>
    </div>
</div> -->